import { fillVariants } from "../../../styles/utils/fill"
import { classNames } from "../../../utils"
import type { IconProps } from "../../types"

export function Outlook({
  size = 24,
  fill = "current",
  fillAttribute = "currentColor",
  className,
  ...rest
}: IconProps) {
  return (
    <svg
      aria-label="Outlook"
      className={classNames(fillVariants({ fill }), className)}
      fill={fillAttribute}
      height={size}
      viewBox="0 0 20 20"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clipPath="url(#clip0_2196_48297)">
        <path d="M19.9999 7.39974C19.9999 7.03335 19.7373 6.73535 19.4161 6.73535H13.6797V8.0629H18.2193L15.2417 10.5165L13.6797 9.23657V10.9207L14.9047 11.9137C15.1037 12.0749 15.3834 12.0749 15.5825 11.9124L18.8323 9.2781V12.7869H13.6797V14.1144H19.4161C19.7373 14.1144 19.9999 13.8177 19.9999 13.4501V7.9884C19.9999 7.97253 19.9987 7.95787 19.9975 7.942C19.9987 7.92612 19.9999 7.91024 19.9999 7.89559V7.39974Z" />
        <path d="M6.24679 12.7419C7.0846 12.7419 7.62197 11.6379 7.62197 9.99036C7.62197 8.62372 7.22505 7.23877 6.24679 7.23877C5.21234 7.23877 4.83008 8.64204 4.83008 9.99036C4.83008 11.5622 5.32593 12.7419 6.24679 12.7419Z" />
        <path d="M0 18.3096L12.4511 19.2231V0.777832L0 1.87334V18.3096ZM6.30435 5.21726C8.43063 5.21726 9.84856 7.14447 9.84856 9.89605C9.84856 13.2461 8.04714 14.7813 6.19077 14.7813C4.16341 14.7813 2.60381 13.0226 2.60381 10.0658C2.60503 7.10661 4.07914 5.21726 6.30435 5.21726Z" />
      </g>
      <defs>
        <clipPath id="clip0_2196_48297">
          <rect height="20" width="20" />
        </clipPath>
      </defs>
    </svg>
  )
}
